<template>
  <g>
    <path
      d="M16 0.298218H2C0.9 0.298218 0 1.19822 0 2.29822V16.2982C0 17.3982 0.9 18.2982 2 18.2982H16C17.1 18.2982 18 17.3982 18 16.2982V2.29822C18 1.19822 17.1 0.298218 16 0.298218ZM16 16.2982H2V2.29822H16V16.2982ZM14.99 6.29822L13.58 4.87822L6.99 11.4682L4.41 8.89822L2.99 10.3082L6.99 14.2982L14.99 6.29822Z"
      fill="#587987"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 16.2982H2V2.29822H16V16.2982ZM13.58 4.87822L14.99 6.29822L6.99 14.2982L2.99 10.3082L4.41 8.89822L6.99 11.4682L13.58 4.87822Z"
      fill="white"
    />
  </g>
</template>
